/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletUpdateReqVo
 */
export interface UserWalletUpdateReqVo {
    /**
     * 用户 ID，关联用户表主键，必传
     * @type {number}
     * @memberof UserWalletUpdateReqVo
     */
    userId: number;
    /**
     * 钱包余额，初始金额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletUpdateReqVo
     */
    amount: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserWalletUpdateReqVo
     */
    currencyCode: string;
    /**
     * 冻结金额，初始冻结金额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletUpdateReqVo
     */
    freezeAmount: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserWalletUpdateReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the UserWalletUpdateReqVo interface.
 */
export function instanceOfUserWalletUpdateReqVo(value: object): value is UserWalletUpdateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('freezeAmount' in value) || value['freezeAmount'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserWalletUpdateReqVoFromJSON(json: any): UserWalletUpdateReqVo {
    return UserWalletUpdateReqVoFromJSONTyped(json, false);
}

export function UserWalletUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'currencyCode': json['currencyCode'],
        'freezeAmount': json['freezeAmount'],
        'enable': json['enable'],
    };
}

export function UserWalletUpdateReqVoToJSON(json: any): UserWalletUpdateReqVo {
    return UserWalletUpdateReqVoToJSONTyped(json, false);
}

export function UserWalletUpdateReqVoToJSONTyped(value?: UserWalletUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
    };
}

